import i18next from 'i18next';
import React, { useEffect } from 'react';
import { I18nextProvider, Translation } from 'react-i18next';

import type { LocaleResource } from './../../ricos-types';

export const RicosTranslate = ({
  children,
  locale,
  localeResource,
}: {
  children: (t: (key: string, options?: any) => string) => React.ReactNode;
  locale: string;
  localeResource: LocaleResource;
}) => {
  const [forceCounter, forceUpdate] = React.useState(0);
  const i18nInstance = React.useMemo(() => {
    const instance = i18next.createInstance({
      lng: locale,
      keySeparator: '$',
      interpolation: { escapeValue: false },
      react: { useSuspense: true },
      resources: { [locale]: { translation: localeResource } },
    });
    instance.init();
    return instance;
  }, []);

  useEffect(() => {
    i18nInstance.addResourceBundle(locale, 'translation', localeResource);
    i18nInstance.changeLanguage(locale, err => {
      if (!err) {
        forceUpdate(forceCounter + 1);
      }
    });
  }, [locale, localeResource]);

  return (
    <I18nextProvider i18n={i18nInstance}>
      <Translation i18n={i18nInstance}>
        {t => {
          return children(t);
        }}
      </Translation>
    </I18nextProvider>
  );
};
